<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary">
  <nb-card-header>
    {{ 'theme.base-history-dialog.title' | translate }}
  </nb-card-header>
  <nb-card-body>
    @if (history) {
      <app-history-list [history]="history"></app-history-list>
    }
    @if (error) {
      <nb-alert outline="danger">{{ 'theme.base-history-dialog.error' | translate }}</nb-alert>
    }
  </nb-card-body>
  <nb-card-footer class="text-right">
    <button nbButton type="button" status="warning"
    (click)="close()">{{ 'theme.base-history-dialog.close' | translate }}</button>
  </nb-card-footer>
</nb-card>
